module.exports = __webpack_public_path__ + "img/logo.664651e2.png";